import { render, staticRenderFns } from "./DevirModalYenidogan.vue?vue&type=template&id=4fa8a78c&"
import script from "./DevirModalYenidogan.vue?vue&type=script&lang=js&"
export * from "./DevirModalYenidogan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports